import { Component } from "react";

import {
  Section,
  FormContainer,
  Title,
  Label,
  Input,
  ButtonGroup,
  ActionButton,
  DataBlock,
  SubTitle,
  UsersWrapper,
  UserCard,
  CardButtonGroup,
  EditButton,
  DeleteButton,
} from "./UserForm.styled.js";

import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { FaUserPlus } from "react-icons/fa6";
import { VscClearAll } from "react-icons/vsc";
import { RxUpdate } from "react-icons/rx";
import { FaUserLargeSlash } from "react-icons/fa6";
import { FaUsersSlash } from "react-icons/fa6";

export class UserForm extends Component {
  state = {
    username: "",
    email: "",
    phone: "",
    users: [],
    editId: null,
  };

  componentDidMount() {
    const savedUsers = localStorage.getItem("users");

    if (savedUsers) {
      this.setState({
        users: JSON.parse(savedUsers),
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.users !== this.state.users) {
      localStorage.setItem("users", JSON.stringify(this.state.users));
    }
  }

  handleChange = (event) => {
    const { name, value } = event.target;

    this.setState({
      [name]: value,
    });
  };

  handleClearForm = () => {
    this.setState({
      username: "",
      email: "",
      phone: "",
      editId: null,
    });
  };

  handleClearUsers = () => {
    this.setState({
      users: [],
    });

    localStorage.removeItem("users");
  };

  handleEdit = (user) => {
    this.setState({
      username: user.username,
      email: user.email,
      phone: user.phone,
      editId: user.id,
    });
  };

  addUsers = (e) => {
    e.preventDefault();

    const username = this.state.username?.trim();
    const email = this.state.email?.trim();
    const phone = this.state.phone?.trim();

    if (!username || !email || !phone) {
      alert("Не всі поля заповнено");
      return;
    }

    const { users, editId } = this.state;

    if (editId) {
      const updatedUsers = users.map((user) =>
        user.id === editId ? { ...user, username, email, phone } : user,
      );

      this.setState({
        users: updatedUsers,
        editId: null,
        username: "",
        email: "",
        phone: "",
      });

      return;
    }

    const newUser = { id: Date.now(), username, email, phone };

    this.setState((prev) => ({
      users: [...prev.users, newUser],
      username: "",
      email: "",
      phone: "",
      editId: null,
    }));
  };

  removeUser = (id) => {
    this.setState((prev) => ({
      users: prev.users.filter((user) => user.id !== id),
    }));
  };

  render() {
    const { username, email, phone, users, editId } = this.state;

    return (
      <Section>
        <FormContainer>
          <Title>
            Форма введення користувача <MdOutlineDriveFileRenameOutline />
          </Title>

          <form onSubmit={this.addUsers}>
            <Label>
              Ім'я користувача:
              <Input
                type="text"
                name="username"
                value={username}
                onChange={this.handleChange}
              />
            </Label>

            <Label>
              Email:
              <Input
                type="email"
                name="email"
                value={email}
                onChange={this.handleChange}
              />
            </Label>

            <Label>
              Телефон:
              <Input
                type="text"
                name="phone"
                value={phone}
                onChange={this.handleChange}
              />
            </Label>

            <ButtonGroup>
              <ActionButton type="submit">
                {editId ? "Оновити" : "Зберегти"}
                {editId ? <RxUpdate /> : <FaUserPlus />}
              </ActionButton>

              <ActionButton type="button" clear onClick={this.handleClearForm}>
                Очистити форму
                <VscClearAll />
              </ActionButton>
            </ButtonGroup>
          </form>

          <DataBlock>
            <SubTitle>Введені дані:</SubTitle>
            <p>Ім'я користувача: {username}</p>
            <p>Email: {email}</p>
            <p>Телефон: {phone}</p>
          </DataBlock>

          <UsersWrapper>
            <SubTitle>Список користувачів:</SubTitle>

            {users.length === 0 ? (
              <p>Немає користувачів</p>
            ) : (
              users.map((user) => (
                <UserCard key={user.id}>
                  <p>
                    <strong>{user.username}</strong>
                  </p>
                  <p>{user.email}</p>
                  <p>{user.phone}</p>

                  <CardButtonGroup>
                    <EditButton onClick={() => this.handleEdit(user)}>
                      Редагувати
                      <RxUpdate />
                    </EditButton>

                    <DeleteButton onClick={() => this.removeUser(user.id)}>
                      Видалити
                      <FaUserLargeSlash />
                    </DeleteButton>
                  </CardButtonGroup>
                </UserCard>
              ))
            )}

            {users.length > 0 && (
              <ActionButton
                type="button"
                danger
                mt
                onClick={this.handleClearUsers}
              >
                Очистити всіх користувачів
                <FaUsersSlash />
              </ActionButton>
            )}
          </UsersWrapper>
        </FormContainer>
      </Section>
    );
  }
}
